import Box from "@memorang/ui/components/Box";
import EmptyState from "@memorang/ui/components/EmptyView";
import { StatsTabContent } from "@memorang/ui/components/LessonDetailStatsTab/StatsTabContent";
import { LessonDetailViewScreen } from "@memorang/ui/components/LessonDetailViewScreen/LessonDetailViewScreen";
import { ModuleArtifactsSection } from "@memorang/ui/components/LessonDetailViewScreen/ModuleArtifactsSection";
import { useRouter } from "expo-router";
import { useMemo } from "react";
import {
	allModules,
	completedModules,
	moduleDetailArtifacts,
	moduleDetailMilestones,
	moduleDetailMiniStats,
	moduleDetailOverallProgress,
	suggestedModules,
} from "../constants";

type Props = {
	moduleId: string;
};

export const ModuleDetailContainer = ({ moduleId }: Props) => {
	const router = useRouter();

	const module = useMemo(
		() =>
			[...allModules, ...suggestedModules, ...completedModules].find(
				(item) => item.id === moduleId,
			),
		[moduleId],
	);

	const handleArtifactPress = () => {
		//TODO: navigate to artifact once module content wiring lands
	};
	const handleTakeQuizPress = () => {
		//TODO: start module quiz once session wiring lands
	};

	const tabs = [
		{
			label: "Content",
			content: (
				<ModuleArtifactsSection
					artifacts={moduleDetailArtifacts}
					onArtifactPress={handleArtifactPress}
				/>
			),
		},
		{
			label: "Stats",
			content: (
				<StatsTabContent
					overallProgress={moduleDetailOverallProgress}
					miniStats={moduleDetailMiniStats}
					milestones={moduleDetailMilestones}
				/>
			),
		},
		{
			label: "Certificate",
			content: (
				<Box minHeight={280}>
					<EmptyState
						title="Certificate coming soon"
						subtitle="Certificate access will be available after the full completion flow is connected."
					/>
				</Box>
			),
		},
	];

	if (!module) {
		return (
			<Box flex={1} justifyContent="center">
				<EmptyState
					title="Module not found"
					subtitle="This module is unavailable. Head back and pick another one."
				/>
			</Box>
		);
	}

	return (
		<LessonDetailViewScreen
			title={module.title}
			description={module.description}
			progressPercent={moduleDetailOverallProgress.percent}
			tabs={tabs}
			coverImage={module.thumbnailUrl}
			bottomCtaLabel="Take the quiz"
			onBackPress={() => router.back()}
			onTakeQuizPress={handleTakeQuizPress}
		/>
	);
};
